import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { moneyFormat } from "../../../../../helpers/appHelpers";

// Helper function
const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

export const ExchangeRateColumns: ColumnDef<any>[] = [
	{
		accessorKey: "fromCurrency",
		header: "From Currency",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => {
			const currency = getValue() as any;
			return `${currency?.name} (${currency?.code})`;
		},
	},
	{
		accessorKey: "toCurrency",
		header: "To Currency",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => {
			const currency = getValue() as any;
			return `${currency?.name} (${currency?.code})`;
		},
	},
	{
		accessorKey: "buyRate",
		header: "Buy Rate",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "sellRate",
		header: "Sell Rate",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];

export const ExchangeRateHistoryColumns: ColumnDef<any>[] = [
	{
		accessorKey: "oldBuyRate",
		header: "Old Buy Rate",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "oldSellRate",
		header: "Old Sell Rate",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "newBuyRate",
		header: "New Buy Rate",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "newSellRate",
		header: "New Sell Rate",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "completed",
		header: "Completed",
		size: 140,
		minSize: 100,
		cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
		sortingFn: (rowA, rowB) => {
			const dateA = new Date(rowA.original.createdAt).getTime();
			const dateB = new Date(rowB.original.createdAt).getTime();
			return dateA - dateB;
		},
	},
];
